module.exports = __webpack_public_path__ + "assets/7b2d5d4a7d29a0507c841286c2a09264.mp3";